export class ScrollInfo {
    constructor() {
        if (!ScrollInfo.instance) {
            this.previousScroll = window.pageYOffset;
            this.handleScroll = this.debounce(this.handleScroll.bind(this), 10); // Throttle scroll event
            window.addEventListener("scroll", this.handleScroll);
            ScrollInfo.instance = this;
        }
        return ScrollInfo.instance;
    }

    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    handleScroll() {
        const currentScroll = window.pageYOffset;

        if (currentScroll === this.previousScroll) {
            return;
        }

        const event = new CustomEvent("scrolling", {
            detail: {
                direction: currentScroll > this.previousScroll ? "down" : "up",
                position: window.pageYOffset,
            },
        });

        document.dispatchEvent(event);

        this.previousScroll = currentScroll;
    }

    destroy() {
        window.removeEventListener("scroll", this.handleScroll);
        ScrollInfo.instance = null;
    }
}
